// Package imports:
import React from 'react';
// Style imports:
// import './StickyHeaderTable.scss';
// Component imports:
// Service imports:
// Type imports:

interface IOwnProps {
    hideScrollbar: boolean;
    setRef?: React.RefObject<HTMLDivElement>;
    children: React.ReactNode;
};
type Props = IOwnProps;

const StickyHeaderTable: React.FC<Props> = ({
    children,
    hideScrollbar,
    setRef
}) => {
    const extraClassName = (hideScrollbar)
        ? 'HideScrollbar'
        : '';
    return (
        <div className='StickyHeaderTable'>
            <div
                className={`TableScrollerWrapper ${extraClassName}`}
                ref={setRef}
            >
                {children}
            </div>
        </div>
    );
}

export default StickyHeaderTable;